<div class="card-details-container">
    <div class="card-detail-header">
        <div class="column">
            <p class="popup-title" style="word-wrap: break-word; max-width: 165px;">{{modelPopUp.product_Id[0]}}</p>
            <span class="result" [ngClass]="{'pass':modelPopUp.statusColor == '',
        'pending':modelPopUp.statusColor != '' && modelPopUp.statusColor != null}">
                <img src="assets/images/cta-tick-white.svg" alt="">
                {{modelPopUp.fillingStatusName}}
            </span>
            <!-- <span class="result pending" *ngIf="true">
                <img src="assets/images/new-set/pending-white.svg" alt="">
                Pending
            </span> -->
        </div>
        <div class="column action-container">
            <!-- <span class="common-tooltip" data-tooltip="Edit"><img src="assets/images/new-set/edit.svg" alt=""></span>
            <span class="common-tooltip" data-tooltip="Download"><img src="assets/images/new-set/download-dark.svg" alt=""></span>
            <span class="common-tooltip" data-tooltip="Report"><img src="assets/images/new-set/report-details-dark.svg" alt=""></span> -->
            <span class="common-tooltip" data-tooltip="Close" (click)="close()"><img src="assets/images/new-set/close.svg" alt=""></span>
        </div>
    </div>
    <div class="schedule-date">
        <img src="assets/images/new-set/calendar-dark.svg" alt="">
        <span>{{modelPopUp.bookingDate | date:'EEEE, d MMM y'}}</span>
    </div>
    
    <div class="badge-container">
        <span class="highlight-badge" style="word-wrap: break-word; max-width: 165px;" *ngFor="let item of modelPopUp.poNumbers| slice : 0 : 2">{{item}}</span> 
        <span class="highlight-badge in-progress font-weight-bold"
        *ngIf="modelPopUp.poNumbers.length >2" style="word-wrap: break-word; max-width: 165px;">+{{modelPopUp.poNumbers.length
        -
        2}}</span>  
    </div>
    
        <!-- *ngFor="let item in modelPopUp.poNumbers | slice:0:2" -->


    <!-- <div class="badge-container">
    <span class="highlight-badge"
      *ngFor="let pos of  modelPopUp.poNumbers | slice:0:2">{{poNumbers}}</span>
	<span class="highlight-badge in-progress font-weight-bold"
	*ngIf="modelPopUp.poNumbers.length >2">+{{modelPopUp.poNumbers.length
	-
	2}}</span>
    </div> -->
    <div class="details-list">
        <img src="assets/images/new-set/location-pin.svg" alt="">
        <div class="detail-text">
            <p class="detail-title">{{modelPopUp.factoryName}}</p>
            <p class="detail-text">{{modelPopUp.factoryAddress}}</p>
        </div>
    </div>
    <div class="details-list">
        <span class="name-initial">B</span>
        <div class="detail-text">
            <p class="detail-text">Booking#</p>
            <p class="detail-title">{{modelPopUp.bookingId}}</p>
        </div>
    </div>
    <div class="details-list">
        <img src="assets/images/new-set/location-pin.svg" alt="">
        <div class="detail-text">
            <p class="detail-text">Supplier</p>
            <p class="detail-title">{{modelPopUp.supplierName}}</p>
        </div>
    </div>
    <div class="details-list" *ngIf="modelPopUp.inspectionResponsible == 5">
        <span class="name-initial" style="background-color: #c79edb">{{getShortName(modelPopUp.inspectionParty)}}</span>
        <div class="detail-text">
            <p class="detail-text">Inspection Responsible</p>
            <p class="detail-title"  style="word-wrap: break-word; max-width: 300px;">{{modelPopUp.inspectionParty}}</p>
        </div>
    </div>
    <div class="details-list align-items-center">
        <img src="assets/images/new-set/case-search.svg" alt="">
        <div class="detail-text">
            <p class="detail-title">{{modelPopUp.serviceType}}</p>
        </div>
    </div>
    <div class="details-list align-items-center">
        <img src="assets/images/new-set/box.svg" alt="">
        <div class="detail-text">
        <span *ngFor="let subcat of modelPopUp.subCategory | slice : 0 : 2">{{subcat}} </span>
            <span
                class="highlight-badge in-progress font-weight-bold"
                *ngIf="modelPopUp.subCategory.length > 2">+{{ modelPopUp.subCategory.length - 2 }}
             </span>              
        </div>
    </div>
    <button class="primary-cta"  (click)="UpdateFilling(modelPopUp.fbReportUrl)">Update Filling</button>
</div>